export const sleep = (time: number) =>
    new Promise((res) => setTimeout(res, time));
